module.exports = __WEBPACK_EXTERNAL_MODULE_230__;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 230
// module chunks = 0